module.exports = __webpack_public_path__ + "img/eye.3a01b25b.svg";